import { Card, CardContent, TextField } from "@mui/material";
import React, { useState } from "react";
import CardTitle from "./CardTitle";
import { useDispatch, useSelector } from "react-redux";
import { updateDataFilterSetting } from "../../reducer/CalcSettingsSlice";
import { DataFilterTypes } from "../../common/common";

export default function FocusCard(props) {
    const calcSettings = useSelector(state => state.calcSettings);
    const focusSetting = calcSettings.changes.dataFilters.find(df => df.type === DataFilterTypes.Focus);
    const [minPointError, setMinPointError] = useState(false);
    const dispatch = useDispatch();

    const handleMinPointChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            let error = (evt.target.value.length === 0) || (Number(evt.target.value) === 0);
            setMinPointError(error);
            dispatch(updateDataFilterSetting({
                type: DataFilterTypes.Focus,
                property: "MinimumPoints",
                value: evt.target.value,
                error: error
            }));
        }
    }
    const renderAttributes = () => {
        if(focusSetting) {
            return(
                <TextField 
                    label="Minimum number of points"
                    value={focusSetting.attributes.MinimumPoints}
                    variant="standard" 
                    onChange={handleMinPointChange}
                    inputProps={{ inputMode: 'numeric', maxLength: 6}}
                    size="small"
                    sx={{paddingRight: "10px"}}
                    error={minPointError}
                    disabled={!focusSetting.enabled}
                />
            );
        } else {
            return ("no settings");
        }
    }

    return(
        <Card variant="outlined" >
            <CardContent >
                <CardTitle title="Focus" />
                {renderAttributes()}
            </CardContent>
        </Card>
    )
}